import type { Preloaded } from '~/types/preloaded';

const preloaded: Preloaded = window.__PRELOADED_STATE__ || {};

export const settings = preloaded.settings || {};
export const urls = preloaded.urls || {};
export const root = urls.root || '/';

export default preloaded;
